import { Alert, Box, Container } from "@mui/material";
import React from "react";
import { useSearchParams } from "react-router-dom";
import useVisitorPreview from "../hooks/useVisitorPreview";
import MuPb from "../widgets/MuPb";
import { getErrorResponse, getReg } from "../utils/util";
import parse from "html-react-parser";
import { BadgePreview } from "../widgets/BadgePreview";

const ResgistrationConfirmation = () => {
  const [searchParams] = useSearchParams();
  const registrationId = searchParams.get("id");
  const id = registrationId || getReg();
  const { data, isLoading, isError, error } = useVisitorPreview(id);
  if (!id) {
    return <Alert severity="error">Registration ID not found.</Alert>;
  }
  if (isLoading) {
    return <MuPb />;
  }
  const parseOptions = {
    replace: (domNode) => {
      if (domNode.name === "img") {
        return (
          <img
            {...domNode.attribs}
            alt={domNode.attribs?.alt || ""}
            style={{
              maxWidth: "100%", // Ensure image doesn't exceed container width
              height: "auto", // Maintain aspect ratio
              display: "block", // Ensure the image is treated as a block element
              margin: "0 auto", // Center-align the image
            }}
          />
        );
      }
    },
  };
  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }
  return (
    <Container maxWidth="md">
      <Box mt={2}>
        {parse(data.preview.prevHeader, parseOptions)}
        <Box display={"flex"} justifyContent={"center"}>
          <BadgePreview
            user={data.user}
            studentBadgeBg={data.preview.studentBadgeBg}
            badgeBg={data.preview.badgeBg}
          />
        </Box>
        <Box mt={2}>{parse(data.preview.prevFooter, parseOptions)}</Box>
      </Box>
    </Container>
  );
};

export default ResgistrationConfirmation;
